import PropTypes from 'prop-types'

import { CAMPAIGN_CHANNEL_EMAIL } from 'Constants/'

import { notifyParent } from 'mailup-react-helpers'
import { Actions, MENU_POSITION_LEFT } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { modalDeleteCampaignState } from '../recoil/state/modals'
import { pageState } from '../recoil/state/page'

const TableActionMenu = ({ item }) => {
  const intl = useIntl()
  const setPageState = useSetRecoilState(pageState)
  const history = useHistory()
  const setModalDeleteCampaignState = useSetRecoilState(
    modalDeleteCampaignState
  )

  // ok
  const handleEdit = (item) => {
    setPageState((prev) => ({
      ...prev,
      loading: true
    }))
    if (item.Type === 1) {
      history.push('/automation/contentsCampaign/' + item.Id + '/0')
    } else {
      notifyParent('redirectMainFrame', [
        'App.aspx#/contentsCampaignWizard/' + item.Id + '/0/' + item.Type
      ])
    }
  }

  // ok
  const handleQuickSend = () => {
    notifyParent('quickSendMessage', [item.IdNl])
  }

  // const handleSentTest = () => {
  //   sentTestMapi(item)
  // }

  // ok
  const handleStats = () => {
    if (item.Type === CAMPAIGN_CHANNEL_EMAIL) {
      notifyParent('redirectMainFrame', [
        'statistics_app_redirector.aspx?r=stats/sendouts/sending/mode/messages/0/' +
          item.IdNl
      ])
    }
  }

  // ok
  const handleSentHistory = () => {
    notifyParent('redirectMainFrame', [
      'statistics_app_redirector.aspx?r=stats/sendouts/sending/mode/messages/0/' +
        item.IdNl
    ])
  }

  const handleDelete = () => {
    setModalDeleteCampaignState((prev) => ({
      ...prev,
      show: true,
      idCampaign: item.Id,
      idMessage: item.IdNl
    }))
  }

  const menuActions = []
  if (!item.ChannelDeleted) {
    menuActions.push({
      label:
        item.Status > 0 && item.Enabled
          ? intl.formatMessage({
              id: 'Load.MailupCommon.Manage'
            })
          : intl.formatMessage({
              id: 'Load.MailupCommon.Edit'
            }),
      onClick: () => handleEdit(item)
    })
  }

  if (
    item.Status > 0 &&
    item.Type === CAMPAIGN_CHANNEL_EMAIL &&
    !item.ChannelDeleted
  ) {
    menuActions.push({
      label: intl.formatMessage({
        id: 'Load.ModalQuickSendNewsletter.Title'
      }),
      onClick: handleQuickSend
    })
  }
  // if (
  //   item.Status > 0 &&
  //   item.Type !== CAMPAIGN_CHANNEL_EMAIL &&
  //   !item.ChannelDeleted
  // ) {
  //   menuActions.push({
  //     label: intl.formatMessage({
  //       id: 'Load.ContentsCampaignWizard.SentTest'
  //     }),
  //     onClick: handleSentTest
  //   })
  // }

  if (item.ShowStats && !item.ChannelDeleted) {
    menuActions.push({
      label: intl.formatMessage({
        id: 'Load.MailupCommon.ActionStatistics'
      }),
      onClick: handleStats
    })
  }

  if (item.ShowSentHistory && !item.ChannelDeleted) {
    menuActions.push({
      label: intl.formatMessage({
        id: 'Load.ContentsCampaignList.SentHistoryAction'
      }),
      onClick: handleSentHistory
    })
  }

  menuActions.push({
    label: intl.formatMessage({
      id: 'Load.MailupCommon.Delete'
    }),
    onClick: handleDelete
  })

  return (
    <Actions
      items={menuActions}
      disabled={item.ActionMenuDisable}
      menuPosition={MENU_POSITION_LEFT}
    />
  )
}

TableActionMenu.propTypes = {
  item: PropTypes.object
}

export default TableActionMenu
